import { query } from 'utils/graphql';

// Actions
const LOAD = 'voyager/events/LOAD';
const LOAD_SUCCESS = 'voyager/events/LOAD_SUCCESS';
const LOAD_FAIL = 'voyager/events/LOAD_LIST_FAIL';
const LOAD_LIST = 'voyager/events/LOAD_LIST';
const LOAD_LIST_SUCCESS = 'voyager/events/LOAD_LIST_SUCCESS';
const LOAD_LIST_FAIL = 'voyager/events/LOAD_LIST_FAIL';
const SHOW_MODAL = 'voyager/events/SHOW_MODAL';
const HIDE_MODAL = 'voyager/events/HIDE_MODAL';

// Reducer
const initialState = {
  loading: false,
  modal: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true,
        event: null,
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        event: action.data.event,
      };
    case LOAD_LIST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.data.events,
      };
    case LOAD_FAIL:
    case LOAD_LIST_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.data.errors,
      };
    case SHOW_MODAL:
      return {
        ...state,
        modal: action.eventId,
      };
    case HIDE_MODAL:
      return {
        ...state,
        modal: null,
      };
    default:
      return state;
  }
}

// Action Creators
export function load(id) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    force: true,
    promise: query`
      query GetEvent(${{ id }}: String!) {
        event(id: $id) {
          id
          actor {
            id
            name
            email
            ip
          }
          timestamp
          message
          context
          diff
        }
      }
    `,
  };
}

export function loadList(force = false) {
  return {
    types: [LOAD_LIST, LOAD_LIST_SUCCESS, LOAD_LIST_FAIL],
    force,
    promise: query`
      query GetEvents {
        events {
          id
          actor {
            id
            name
            email
            ip
          }
          timestamp
          message
        }
      }
    `,
  };
}

export function showModal(eventId) {
  return {
    type: SHOW_MODAL,
    eventId,
  };
}

export function hideModal() {
  return {
    type: HIDE_MODAL,
  };
}
